import { Icon, Stack, Typography } from '@mui/material';
import useColorsStyles from 'common/colors';
import CustomTooltip from 'common/components/CustomTooltip';
import useFlexBoxStyles from 'common/flexBox';
import useFontStyles from 'common/fontStyles';
import useOnliveStyles from 'common/onliveStyles';
import parse from 'html-react-parser';
import { useTranslation } from 'react-i18next';
import { keyframes } from 'tss-react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => {
    const glow = keyframes`
    0% {
        opacity: 0.5;
        textShadow: 0 0 3px rgba(255, 255, 255, 0.3), 0 0 3px #ff3f40;
    }
    100% {
        opacity: 1;
        textShadow:
            0 0 5px rgba(255, 255, 255, 0.3), 0 0 10px rgba(255, 255, 255, 0.3), 0 0 8px #ff3f40, 0 0 12px #ff3f40;
    }
    }`;

    return {
        root: {
            animation: `${glow} 1s ease-in-out infinite alternate`,
            height: theme.spacing(4),
            [theme.breakpoints.up('xl')]: {
                height: theme.spacing(5),
            },
            [theme.breakpoints.down('lt')]: {
                height: theme.spacing(3.5),
            },
        },
        link: {
            '&:visited ': {
                color: 'black',
                textDecoration: 'none',
            },

            '&:link ': {
                color: 'black',
                textDecoration: 'none',
            },
        },
    };
});

const PromotionalBannerText = (props) => {
    const { promotion, info, mobile, disabled } = props;
    const { classes, cx } = useStyles();
    const { classes: flexBox } = useFlexBoxStyles();
    const { classes: colors } = useColorsStyles();
    const { classes: font } = useFontStyles();
    const { classes: onlive } = useOnliveStyles();
    const { t } = useTranslation();

    const iconClass = cx(colors.textWhite, colors.bgBlack, flexBox.padding05, onlive.darkBorder);

    const bannerText = (
        <Typography className={cx(font.clamp, font.clampLine2, font.lineHeight1, flexBox.padding05)}>
            {parse(promotion.text)}
        </Typography>
    );

    return (
        <Stack
            direction="row"
            alignItems="center"
            className={cx(
                classes.root,
                flexBox.borderRadius1,
                colors.bgPaper,
                onlive.darkBorder,
                flexBox.borderBox,
                flexBox.padding0,
                flexBox.overflowHidden,
                flexBox.margin1,
                onlive.boxShadowWeb,
            )}
        >
            <Icon className={iconClass}>campaign</Icon>

            {Boolean(promotion.url) && !info && !disabled ? (
                <CustomTooltip
                    arrow
                    disableHoverListener={mobile}
                    title={t('callToAction.callToActionItem.promoLink')}
                    placement={'bottom'}
                >
                    <a className={classes.link} target={'_blank'} href={promotion.url} rel="noopener noreferrer">
                        {bannerText}
                    </a>
                </CustomTooltip>
            ) : (
                bannerText
            )}
        </Stack>
    );
};

export default PromotionalBannerText;
